import axios from 'axios';

// Compute backend base URL:
// - In deployed production (custom domain or *.emergent.host), call same-origin "/api"
//   to avoid iOS Safari third-party-cookie blocking on session cookies.
// - In dev/preview, use REACT_APP_BACKEND_URL.
const getBackendOrigin = () => {
  if (typeof window !== 'undefined') {
    const host = window.location.hostname;
    if (host === 'smt-services17.fr' || host === 'www.smt-services17.fr' || host.endsWith('.emergent.host')) {
      return window.location.origin;
    }
  }
  return process.env.REACT_APP_BACKEND_URL || '';
};

const BACKEND_URL = getBackendOrigin();
export const API = `${BACKEND_URL}/api`;

// Axios instance with cookie credentials for auth
const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const authApi = {
  exchangeSession: (sessionId) =>
    api.post('/auth/session', { session_id: sessionId }),
  me: () => api.get('/auth/me'),
  logout: () => api.post('/auth/logout'),
};

export const adminApi = {
  listQuotes: (status) =>
    api.get('/admin/quotes', { params: status && status !== 'all' ? { status } : {} }),
  getQuote: (id) => api.get(`/admin/quotes/${id}`),
  updateStatus: (id, status) => api.patch(`/admin/quotes/${id}`, { status }),
  deleteQuote: (id) => api.delete(`/admin/quotes/${id}`),
  sendReviewEmail: (id) => api.post(`/admin/quotes/${id}/send-review-email`),
  stats: () => api.get('/admin/stats'),
  exportUrl: () => `${API}/admin/quotes/export`,
};

export const catalogApi = {
  list: (kind) => api.get(`/admin/${kind}`),
  create: (kind, data) => api.post(`/admin/${kind}`, data),
  update: (kind, id, data) => api.patch(`/admin/${kind}/${id}`, data),
};

export const clientsApi = {
  list: (params) => api.get('/admin/clients', { params }),
  get: (id) => api.get(`/admin/clients/${id}`),
  byQuote: (quoteId) => api.get(`/admin/clients/by-quote/${quoteId}`),
  merge: (id, otherId) => api.post(`/admin/clients/${id}/merge`, { other_id: otherId }),
  unmerge: (id, otherId) => api.post(`/admin/clients/${id}/unmerge`, { other_id: otherId }),
  dismiss: (id, otherId) => api.post(`/admin/clients/${id}/dismiss-duplicate`, { other_id: otherId }),
};

export const availabilityApi = {
  settings: () => api.get('/admin/availability/settings'),
  saveSettings: (data) => api.put('/admin/availability/settings', data),
  preview: (service, options = '') => api.get('/admin/availability/preview', { params: { service, options } }),
  listUnav: () => api.get('/admin/unavailabilities'),
  addUnav: (data) => api.post('/admin/unavailabilities', data),
  removeUnav: (id) => api.delete(`/admin/unavailabilities/${id}`),
};

export default api;
